import { useRouter } from 'next/router';
import { faXmark } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import styles from './DiscountBundleWarningModal.module.scss';

const buttonClasses =
  'border-2 border-primary w-100 w-sm-auto px-24 py-6 fs-10';

function DiscountBundleWarningModal({
  showModal,
  onCancel,
  header = 'Leave Bundle?',
  advisory = 'Already added items will remain in your cart.',
}) {
  const router = useRouter();
  const handleYesClick = () => {
    router.push('/specials');
  };

  const handleNoClick = () => onCancel();

  return (
    <Modal
      centered
      // backdropClassName="opacity-15"
      id="discount-bundle-warning"
      show={showModal}
      size="lg"
    >
      <Modal.Body className="p-0 rounded border-primary border-2">
        <div
          className={classNames(
            'd-flex flex-column align-items-center mb-20 mt-20'
          )}
        >
          <button
            className={classNames(
              'position-absolute border-0 bg-transparent font-sofia px-0',
              styles.close_button
            )}
            id="warning_modal_close"
            title="Close"
            type="button"
            onClick={() => {
              onCancel();
            }}
          >
            <span>
              <FontAwesomeIcon className={styles.icon} icon={faXmark} />
            </span>
          </button>
          <div
            className={classNames(
              'text-primary text-center p-0 fs-16 font-frl'
            )}
          >
            {header}
          </div>
          <div className="text-primary px-8 fs-10 font-frl text-center">
            {advisory}
          </div>
          <div className="d-flex flex-column w-75 w-lg-50 justify-content-center text-center py-12">
            <Button
              className={classNames('mb-2 mb-lg-4 text-primary', buttonClasses)}
              variant="secondary"
              onClick={handleNoClick}
            >
              No
            </Button>
            <Button
              className={classNames('mt-2 mt-lg-4 text-primary', buttonClasses)}
              variant=""
              onClick={handleYesClick}
            >
              Yes
            </Button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default DiscountBundleWarningModal;
